module.exports = __webpack_public_path__ + "img/sb_r.png?7be4b34e8f835d31e42cc2ba1467a7c5";